import Debug from 'debug'

import { PLUGIN_NAME } from './constant'

export const debug = Debug(PLUGIN_NAME)
